"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./MiniHorizontalBarChart.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The MiniHorizontalBarChart component is a small, non-interative variant of
 * the HorizontalBarChart, used to provide very brief, at-a-glance information.
 * It's primary use-case is in the OptionChain component, and should be
 * accompanied by additional information.
 */
const MiniHorizontalBarChart = ({
  labelBottom,
  labelTop,
  valueBottom = 0,
  variant = 'positive',
  valueTop = 0,
  maxValue = 0,
  ...otherProps
}) => {
  const topValuePercentage = Math.round(valueTop / maxValue * 100);
  const bottomValuePercentage = Math.round(valueBottom / maxValue * 100);
  return (0, _pragma.createFelaElement)(_.View, _extends({
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between"
  }, otherProps), (0, _pragma.createFelaElement)(_.View, {
    css: css.charts,
    flexDirection: "column",
    margin: [0, 12, 0, 0]
  }, (0, _pragma.createFelaElement)(_.View, {
    "aria-label": "".concat(valueTop),
    css: css.topBar,
    cssProps: {
      variant
    },
    style: {
      width: "".concat(topValuePercentage, "%")
    }
  }), (0, _pragma.createFelaElement)(_.View, {
    "aria-label": "".concat(valueBottom),
    css: css.bottomBar,
    cssProps: {
      variant
    },
    style: {
      width: "".concat(bottomValuePercentage, "%")
    }
  })), labelBottom || labelTop ? (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column"
  }, (0, _pragma.createFelaElement)(_.Text, {
    children: labelTop,
    color: "text.1",
    variant: "meta"
  }), (0, _pragma.createFelaElement)(_.Text, {
    children: labelBottom,
    variant: "meta"
  })) : null);
};

MiniHorizontalBarChart.displayName = 'MiniHorizontalBarChart';
var _default = MiniHorizontalBarChart;
exports.default = _default;
//# sourceMappingURL=MiniHorizontalBarChart.js.map